import PropTypes from 'prop-types';
import React from 'react';
import ShareFavourites from 'atoms/sharing-favourites';


export default function PageEstablishmentInline({ className, image, quote, handleFaceBookCick, handleCopyCick, handleSaveCick, isSaved, isCopied, isProcessing, t }) {
  return (
    <div className={ `page-establishment-inline ${className}` }>
      <div className="page-establishment-inline__first">
        <img alt="" className="page-establishment-inline__first__image" src={ image } />
        <span className="page-establishment-inline__first__quote">
          { quote }
        </span>
      </div>
      <ShareFavourites
        handleCopyClick={ handleCopyCick }
        handleFacebookShareClick={ handleFaceBookCick }
        handleSaveClick={ handleSaveCick }
        isCopied={ isCopied }
        isProcessing={ isProcessing }
        isSaved={ isSaved }
        t={ t }
      />
    </div>
  );
}

PageEstablishmentInline.defaultProps = {
  className: '',
};

PageEstablishmentInline.propTypes = {
  className: PropTypes.string,
  handleCopyCick: PropTypes.func.isRequired,
  handleFaceBookCick: PropTypes.func.isRequired,
  handleSaveCick: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  isCopied: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired,
  quote: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,

};
